// Thin GA4 event helper. The gtag loader lives in index.html with an inert
// placeholder Measurement ID — until the real G- ID is set there, gtag never
// loads and track() is a silent no-op, so calls are always safe.
export function track(name: string, params?: Record<string, unknown>): void {
  const w = window as unknown as { gtag?: (...args: unknown[]) => void };
  if (typeof w.gtag === 'function') {
    w.gtag('event', name, params || {});
  }
}
